import { useDocumentTitle } from "@uidotdev/usehooks";
import { DataDownloadDataTable } from "../components/DownloadsDataTable";
import { DashboardContainer, DashboardHeader } from "../ui/DashboardComponents";
import { PermissionGate } from "./PermissionGate";

export const DataDownloadPage = () => {
    useDocumentTitle("Data Downloads - AERSHED");

    return (
        <PermissionGate permission="dataDownloadView">
            <DashboardContainer>
                <DashboardHeader title="Data Downloads" />
                <DataDownloadDataTable />
            </DashboardContainer>
        </PermissionGate>
    );
};
